import * as React from 'react';
import ReactPaginate from 'react-paginate';

interface IPaginationProps {
  currentPage: number;
  limit: number;
  totalRecords: number;
  pathname: string;
  search: string;
  refNextButton: (ref: any) => void;
  onPageChanged: (page: number, reset: boolean) => void;
  doNotGenerateSSRLinks?: boolean;
}

const Pagination = (props: IPaginationProps) => {
  const pagesLength = Math.ceil(props.totalRecords / props.limit);
  const { search, pathname, doNotGenerateSSRLinks } = props;

  const hrefBuilder = (page: number) => {
    let searchParams = null;
    if (URLSearchParams) {
      searchParams = new URLSearchParams(search);
      if (page > 1) {
        searchParams.set('page', String(page));
      } else {
        searchParams.delete('page');
      }
    }

    let s = search.substring(1);
    if (searchParams) {
      s = searchParams.toString();
    }

    return pathname + '?' + s;
  }; 

  return (
    <div className="row">
      <div className="pagination col-md-12">
        <ReactPaginate
          hrefBuilder={doNotGenerateSSRLinks ? undefined : hrefBuilder}
          previousLabel={null}
          previousClassName={'hidden'}
          nextLabel={null}
          nextClassName={'hidden'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pagesLength}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          forcePage={props.currentPage - 1}
          onPageChange={(selectedItem: any) => props.onPageChanged(selectedItem.selected + 1, true)}
          activeClassName={'active'}
        />
      </div>
    </div>);
};
export default Pagination;



// WEBPACK FOOTER //
// ./src/modules/Pagination/Pagination.tsx